export const ONBOARDING_STORAGE_KEY = "sport-journal:onboarding-selection";

export interface PendingOnboardingSelection {
  sportId: string;
  goalId: string;
}
